/**
 * Role labels — שמות התפקידים
 *
 * One place, because the same four words appear in the user table, the user
 * detail modal and the profile page, and a role added in only two of the three
 * shows up as "לקוח" in the one that was missed.
 */

const ROLE_LABELS: Record<string, string> = {
  admin: 'מנהל',
  advisor: 'יועץ',
  sub_admin: 'מנהל אזור',
  student: 'תלמיד',
  client: 'לקוח',
  user: 'לקוח',
}

export function roleLabel(role?: string): string {
  return ROLE_LABELS[String(role)] ?? 'לקוח'
}
